import React, { useState } from "react";
import "./Signup.css";
import logoicon from "../../images/logo-icon.svg";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import logolight from "../../images/urology-logo-white.svg";
import { Link, useNavigate } from "react-router-dom";
import mailiconinput from "../../images/mailicon-input.svg";
import mobileicon from "../../images/mobileicon.svg";
import { useFormik } from "formik";
import { formiksignup } from "./validation";
import { toast } from "react-toastify";
import ProviderService from "../services/providerService";
import ProviderServiceAdmin from "../../admin/services/providerService";
import calendaricon from "../../images/calendar.svg";
import urologylogotransparent from '../../images/urology-logo-transparent.png';
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { countries } from "countries-list";
import { Autocomplete, TextField } from "@mui/material";

// Custom connector for stepper
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#008000",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#008000",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
  },
}));

function SignupComponent() {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const steps = ["Account Details", "Medical Setting", "Agree to Terms"];
  const [isValidInviteCode, setIsValidInviteCode] = useState(true);

  const formik = useFormik({
    ...formiksignup,
    onSubmit: async (values) => {
      try {
        const res = await ProviderService.registration(values);
        if (res.data.status === "SUCCESS") {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        navigate("/signin");
      } catch (error) {
        toast.error("Registration failed!");
        navigate("/signin");
      }
    },
  });

  const handleNext = () => {
    if (activeStep <= 1) {
      // if (activeStep === 0 || activeStep === 1) {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors).length === 0) {
          if (activeStep == 1) {
            // Check if invite code is valid before proceeding
            if (formik.values.invideCode.length === 6 && !isValidInviteCode) {
              formik.setTouched({
                invideCode: true,
              });
              toast.error("Please enter a valid invite code.");
              return;
            }
          }
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
          formik.setTouched({
            firstName: true,
            lastName: true,
            primaryPhone: true,
            email: true,
            gender: true,
            dob: true,
            medicalSetting: true,
            countyrOpractice: true,
          });
          toast.error("Please fill in all required fields correctly.");
        }
      });
    }
  };

  const handleSubmit = () => {
    if (formik.values.terms && formik.values.terms1) {
      formik.handleSubmit();
    } else {
      formik.setFieldTouched("terms", true, true);
      formik.setFieldTouched("terms1", true, true);

      toast.error("You must accept the terms to proceed.");
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  // MEDICAL SETTING OPTIONS
  const options = [
    "Hospital",
    "Private Practice",
    "Clinic",
    "Academic Medical Center",
    "Other",
    "General Practitioner",
    "Family Medicine",
    "Cardiology",
    "Neurology",
    "Orthopedics",
    "Pediatrics",
    "Gastroenterology",
    "Rheumatology",
    "Dermatology",
    "Endocrinology",
    "Psychiatry",
    "Oncology",
    "Urology",
    "Gynecology",
    "Ophthalmology",
    "Pulmonary",
    "Neurosurgery",
    "Orthopedics",
    "Pediatrics",
    "Gastroenterology",
    "Rheumatology",
    "Dermatology",
    "Endocrinology",
  ];
  const uniqueSortedOptions = [...new Set(options)].sort();

  // Medical speciality options
  const specialityOptions = [
    "Cardiology",
    "Neurology",
    "Orthopedics",
    "Surgery",
    "Pediatrics",
    "Gastroenterology",
    "Urology",
    "Oncology",
    "Rheumatology",
    "Dermatology",
    "Psychiatry",
    "Ophthalmology",
    "Gynecology",
    "Endocrinology",
    "Psychology",
    "Dermatology",
    "Nephrology",
    "Hematology",
    "Immunology",
    "Pediatrics",
    "Otorhinolaryngology",
    "Urology",
    "General Medicine",
    "Anesthesiology",
    "Cardiology",
    "Pulmonary Medicine",
    "Neurology",
    "Orthopedics",
  ];
  // invite code

  // CHECK INVITE CODE
  const checkInviteCode = async (code) => {
    try {
      const response = await ProviderServiceAdmin.checkInviteCode(code);
      if (response.exists) {
        // formik.setFieldValue("invideCode", "");
        toast.error("Invite code is Already used");

        formik.setFieldError("invideCode", "Invite code is Already used");
        setIsValidInviteCode(false);
      } else {
        toast.success("Invite code is available");
        setIsValidInviteCode(true);
      }
    } catch (error) {
      toast.error("Failed to check invite code");
    }
    formik.setFieldTouched("invideCode", true);
  };

  const uniqueSortedSpecialityOptions = [...new Set(specialityOptions)].sort();
  return (
    <>
      <section className="signup-blk">
        <div className="bg-blk">
          <div className="logo-top">
            <img src={urologylogotransparent} alt="logo" />
          </div>
        </div>
        <div className="signup-text-blk">
          <div className="signup-content">
            <div className="logoicon">
              <img src={logoicon} alt="logo" />
            </div>
            <div className="signup-main-text">
              {/* Stepper inside the form section */}
              <Stack sx={{ width: "100%", marginBottom: 4 }} spacing={4}>
                <Stepper
                  alternativeLabel
                  activeStep={activeStep}
                  connector={<CustomConnector />}
                >
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel />
                    </Step>
                  ))}
                </Stepper>
              </Stack>

              <h2>Sign up</h2>
              <p>Enter your details for creating an account.</p>
              <Form onSubmit={formik.handleSubmit}>
                {activeStep === 0 && (
                  <>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>First Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter first name"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.firstName &&
                              !!formik.errors.firstName
                            }
                          />
                          {formik.touched.firstName &&
                            formik.errors.firstName ? (
                            <div className="text-danger">
                              {formik.errors.firstName}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter last name"
                            name="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.touched.lastName &&
                              !!formik.errors.lastName
                            }
                          />
                          {formik.touched.lastName && formik.errors.lastName ? (
                            <div className="text-danger">
                              {formik.errors.lastName}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Mobile Number</Form.Label>
                          <div className="input-left-icon">
                            <img src={mobileicon} alt="icon" />
                            <Form.Control
                              type="tel"
                              placeholder="Enter Mobile No."
                              name="primaryPhone"
                              value={formik.values.primaryPhone}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.primaryPhone &&
                                !!formik.errors.primaryPhone
                              }
                            />
                          </div>
                          {formik.touched.primaryPhone &&
                            formik.errors.primaryPhone ? (
                            <div className="text-danger">
                              {formik.errors.primaryPhone}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <div className="input-left-icon">
                            <img src={mailiconinput} alt="icon" />
                            <Form.Control
                              type="email"
                              placeholder="Enter mail address"
                              name="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.email && !!formik.errors.email
                              }
                            />
                          </div>
                          {formik.touched.email && formik.errors.email ? (
                            <div className="text-danger">
                              {formik.errors.email}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={5}>
                        <Form.Label>Gender</Form.Label>
                        {/* <Form.Select
                          name="gender"
                          value={formik.values.gender}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.gender && !!formik.errors.gender
                          }
                        >
                          <option cl>Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </Form.Select> */}
                        <Form.Select
                          name="gender"
                          className={`gender-select ${!formik.values.gender ? 'gender-placeholder' : ''}`}
                          value={formik.values.gender}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.gender && !!formik.errors.gender
                          }
                          style={{
                            color: !formik.values.gender ? '#999' : '#000'
                          }}
                        >
                          <option value="" disabled>
                            Select Gender
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </Form.Select>

                        {formik.touched.gender && formik.errors.gender ? (
                          <div className="text-danger">
                            {formik.errors.gender}
                          </div>
                        ) : null}
                      </Col>
                      <Col lg={7}>
                        {/* <Form.Group className="mb-3">
                          <Form.Label>Date of birth (Optional)</Form.Label>
                          <div className="input-ryt-icon">
                            <img src={calendaricon} alt="icon" />
                            <Form.Control
                              type="date"
                              name="dob"
                              value={formik.values.dob}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.dob && !!formik.errors.dob
                              }
                            />
                          </div>
                        </Form.Group> */}
                        <Form.Group className="mb-3">
                          <Form.Label>Date of birth (Optional)</Form.Label>
                          <div className="date-input">
                            <img src={calendaricon} alt="icon" />
                            <Form.Control
                              type="date"
                              name="dob"
                              className={!formik.values.dob ? 'date-placeholder' : ''}
                              value={formik.values.dob}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.touched.dob && !!formik.errors.dob
                              }
                              style={{
                                color: !formik.values.dob ? '#999' : '#000'
                              }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
                {activeStep === 1 && (
                  <Row>
                    <Col lg={5}>
                      <Form.Label>Medical Setting</Form.Label>
                      <Form.Select
                        name="medicalSetting"
                        className={`medical-setting-select ${!formik.values.medicalSetting ? 'select-placeholder' : ''}`}
                        value={formik.values.medicalSetting || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.touched.medicalSetting &&
                          !!formik.errors.medicalSetting
                        }
                        style={{
                          color: !formik.values.medicalSetting ? '#999' : '#000'
                        }}
                      >
                        <option value="" disabled>Select</option>
                        {uniqueSortedOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col lg={7}>
                      <Form.Label>Country Of Practice</Form.Label>
                      <Autocomplete
                        className="country"
                        id="country-practice-autocomplete"
                        options={Object.values(countries).map(
                          (country) => country.name
                        )} // Getting the country names
                        onChange={(event, value) => {
                          formik.setFieldValue("countyrOpractice", value);
                        }}
                        value={formik.values.countyrOpractice || ""}
                        renderInput={(params) => (
                          <TextField
                            className="form-select"
                            {...params}
                            // label="Select Country"
                            placeholder="Select Country"
                            variant="outlined"
                            error={
                              formik.touched.countyrOpractice &&
                              Boolean(formik.errors.countyrOpractice)
                            }
                            helperText={
                              formik.touched.countyrOpractice &&
                              formik.errors.countyrOpractice
                            }
                          />
                        )}
                      />
                    </Col>
                    <Col lg={12} className="mt-3">
                      <Form.Label>Medical Speciality</Form.Label>
                      <Form.Select
                        name="medicalSpeciality"
                        className={`medical-speciality-select ${!formik.values.medicalSpeciality ? 'select-placeholder' : ''}`}
                        value={formik.values.medicalSpeciality || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.touched.medicalSpeciality &&
                          !!formik.errors.medicalSpeciality
                        }
                        style={{
                          color: !formik.values.medicalSpeciality ? '#999' : '#000'
                        }}
                      >
                        <option value="" disabled>Select Speciality</option>
                        {uniqueSortedSpecialityOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                      {formik.touched.medicalSpeciality &&
                        formik.errors.medicalSpeciality ? (
                        <div className="text-danger">
                          {formik.errors.medicalSpeciality}
                        </div>
                      ) : null}
                    </Col>
                    {/* invite code  */}
                    <Col lg={12} className="mt-3">
                      <Form.Label>Invite Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="invideCode"
                        placeholder="Enter 6 digit invite code"
                        maxLength={6}
                        value={formik.values.invideCode}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only digits and max 6 characters
                          if (/^\d{0,6}$/.test(value)) {
                            formik.setFieldValue("invideCode", value);
                            if (value.length === 6) {
                              checkInviteCode(value); // Call your API here
                            }
                          }
                        }}
                        onBlur={formik.handleBlur}
                        isInvalid={
                          formik.touched.invideCode &&
                          !!formik.errors.invideCode
                        }
                      />
                      {formik.touched.invideCode &&
                        formik.errors.invideCode && (
                          <div className="text-danger">
                            {formik.errors.invideCode}
                          </div>
                        )}
                      {isValidInviteCode &&
                        formik.values.invideCode?.length == 6 && (
                          <div className="text-success">
                            Invite code is available
                          </div>
                        )}
                      {!isValidInviteCode &&
                        formik.values.invideCode?.length == 6 && (
                          <div className="text-danger">
                            Invite code is not available
                          </div>
                        )}
                    </Col>
                  </Row>
                )}

                {activeStep === 2 && (
                  <Row>
                    <Col lg={12}>
                      <span className="privacy-txt">
                        We take privacy very seriously and are GDPR compliant.
                        Read more about how we protect data on our blog post and
                        our privacy policy.
                      </span>
                      <Form.Group className="mb-4 mt-3">
                        <Form.Check
                          className="privacy-chk"
                          type="checkbox"
                          name="terms"
                          label="I am a professional health provider"
                          onChange={formik.handleChange}
                          checked={formik.values.terms}
                          isInvalid={
                            formik.touched.terms && !!formik.errors.terms
                          }
                        />
                        {formik.touched.terms && formik.errors.terms ? (
                          <div className="text-danger">
                            {formik.errors.terms}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Form.Group className="mb-4 mt-3">
                        <Form.Check
                          className="privacy-chk"
                          type="checkbox"
                          name="terms1"
                          label="I agree to the Terms of service and the Data Protection Agreement"
                          onChange={formik.handleChange}
                          checked={formik.values.terms1}
                          isInvalid={
                            formik.touched.terms1 && !!formik.errors.terms1
                          }
                        />
                        {formik.touched.terms1 && formik.errors.terms1 ? (
                          <div className="text-danger">
                            {formik.errors.terms1}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                <div className="mt-4">
                  {activeStep < steps.length - 1 && (
                    <Button
                      // className="primary signin-btn nextbtn"
                      className="nextbtn"
                      onClick={handleNext}
                    >
                      Next
                    </Button>
                  )}

                  {activeStep >= 2 && (
                    <Button
                      className="primary signin-btn nextbtn"
                      onClick={handleSubmit}
                    >
                      Sign Up
                    </Button>
                  )}
                </div>
              </Form>
              <p className="mt-3">
                Already have an account? <Link to="/signin">Log in here</Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SignupComponent;
